<script setup lang="ts">
defineExpose({
  name: 'ExceptionIcon',
});
</script>

<template>
  <svg
    class="ExceptionIcon"
    width="38"
    height="39"
    viewBox="0 0 38 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 21.65H20.5V9.65H17.5V21.65ZM19 28.95C19.4667 28.95 19.85 28.8 20.15 28.5C20.45 28.2 20.6 27.8167 20.6 27.35C20.6 26.8833 20.45 26.5 20.15 26.2C19.85 25.9 19.4667 25.75 19 25.75C18.5333 25.75 18.15 25.9 17.85 26.2C17.55 26.5 17.4 26.8833 17.4 27.35C17.4 27.8167 17.55 28.2 17.85 28.5C18.15 28.8 18.5333 28.95 19 28.95ZM19 38.5C16.3667 38.5 13.892 38 11.576 37C9.25867 36 7.25 34.65 5.55 32.95C3.85 31.25 2.5 29.2413 1.5 26.924C0.5 24.608 0 22.1333 0 19.5C0 16.8667 0.5 14.3913 1.5 12.074C2.5 9.758 3.85 7.75 5.55 6.05C7.25 4.35 9.25867 3 11.576 2C13.892 1 16.3667 0.5 19 0.5C21.6333 0.5 24.1087 1 26.426 2C28.742 3 30.75 4.35 32.45 6.05C34.15 7.75 35.5 9.758 36.5 12.074C37.5 14.3913 38 16.8667 38 19.5C38 22.1333 37.5 24.608 36.5 26.924C35.5 29.2413 34.15 31.25 32.45 32.95C30.75 34.65 28.742 36 26.426 37C24.1087 38 21.6333 38.5 19 38.5ZM19 35.5C23.4333 35.5 27.2087 33.942 30.326 30.826C33.442 27.7087 35 23.9333 35 19.5C35 15.0667 33.442 11.2913 30.326 8.174C27.2087 5.058 23.4333 3.5 19 3.5C14.5667 3.5 10.792 5.058 7.676 8.174C4.55867 11.2913 3 15.0667 3 19.5C3 23.9333 4.55867 27.7087 7.676 30.826C10.792 33.942 14.5667 35.5 19 35.5Z"
      fill="#C33B2E"
      stroke="#C33B2E"
    />
  </svg>
</template>

<style lang="scss" scoped>
.ExceptionIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
